
export default function Testimonial() {
  return (
    <section className="py-24 bg-[#F5F1E8]">
      <div className="max-w-7xl mx-auto px-8">
        <div className="bg-[#0A0A0A] rounded-3xl overflow-hidden flex">
          {/* Image Section */}
          <div className="w-2/5 relative -ml-8">
            <img
              src="https://public.readdy.ai/ai/img_res/c79578c181c67419f20cb9d94c79e909.jpg"
              alt="Happy Customer"
              className="w-full h-full object-cover object-top rounded-2xl"
            />
          </div>

          {/* Content Section */}
          <div className="w-3/5 p-16 flex flex-col justify-center">
            <div className="mb-8">
              <i className="ri-double-quotes-l text-6xl text-[#F5F1E8]/30"></i>
            </div>

            <blockquote className="text-2xl text-white leading-relaxed mb-12 font-light">
              Fine Frank transformed our kitchen beyond our expectations. The custom cabinets are absolutely stunning, and their handyman team fixed several issues we had throughout the house. True professionals!
            </blockquote>

            <div className="mb-8">
              <p className="text-white text-lg font-semibold mb-1">Michael & Sarah Peterson</p>
              <p className="text-gray-400 text-sm">Residential Remodeling Client</p>
            </div>

            <button className="self-start px-8 py-3 bg-[#FFB8C6] text-gray-900 font-semibold rounded-full hover:bg-[#ffa8ba] transition-colors cursor-pointer whitespace-nowrap">
              Read More Reviews
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
